import api from '@app/api'

import { CONTENT_TYPES } from '@app/api/constants'

import type {
  AddMonitoringListsProductsData,
  ExportMonitoringListsProductsTemplate,
  RemoveMonitoringListsProductsData,
  UpdateMonitoringListsProductsData
} from './types'

const URL = 'monitoring-lists/products/'

export const addMonitoringListsProducts = async (data: AddMonitoringListsProductsData): Promise<void> => {
  await api.post(URL, data)
}

export const removeMonitoringListsProducts = async (data: RemoveMonitoringListsProductsData): Promise<void> => {
  const url = `${URL}remove/`
  await api.post(url, data)
}

export const updateMonitoringListsProducts = async (data: UpdateMonitoringListsProductsData): Promise<void> => {
  const url = `${URL}update/`
  await api.patch(url, data)
}

export const exportMonitoringListsProductsTemplate = async (
  params: ExportMonitoringListsProductsTemplate,
  signal?: AbortSignal
): Promise<Blob> => {
  const response = await api.get<Blob>(`${URL}export/template/`, {
    signal,
    params,
    responseType: 'blob',
    headers: {
      'Content-Type': CONTENT_TYPES.applicationOfficedocumentSpreadsheetml
    }
  })

  return response.data
}

export const importMonitoringListsProducts = async (data: FormData): Promise<void> => {
  const url = `${URL}import/`
  const config = { headers: { 'Content-Type': CONTENT_TYPES.multipartFormData } }
  await api.post(url, data, config)
}
